import React from 'react';
import Image from 'next/image';
import NoSSR from 'react-no-ssr';

import CTA from 'react-scale/components/ui/cta';

const Overview = ({overtitle, title, text, cta, img, theme}) => (
  <div className="grid items-center gap-10 lg:gap-20 md:grid-cols-2">
    <div className="mb-10 lg:mb-0">
      {overtitle && (
        <h4 className="inline-block mb-4 text-overtitle text-gradient">
          {overtitle}
        </h4>
      )}
      <h1 className="mb-6 text-2xl text-white lg:text-4xl font-aeonik">{title}</h1>
      <NoSSR>
        <p className="text-lg" dangerouslySetInnerHTML={{ __html: text }} />
      </NoSSR>
      {cta && (
        <div className="pt-5 mt-6 border-t border-gray-800 pb-7">
          <CTA theme={theme} cta={cta} />
        </div>
      )}
    </div>
    {img && (
      <>
        <div className="hidden md:block">
          <Image
            src={img.src}
            alt={img.alt}
            width={924}
            height={757}
            unoptimized
            layout="fixed"
            objectFit="cover"
          />
        </div>
        <div className="md:hidden">
          <Image
            src={img.src}
            alt={img.alt}
            width={924}
            height={757}
            unoptimized
            layout="responsive"
          />
        </div>
      </>
    )}
  </div>
);

Overview.defaultProps = {
  img: {
    src: '/static/images/pages/rapid-university/overview-example.png',
    alt: 'overview-dashboard'
  }
};

export default Overview;
